//przy opisie pamietac by opisac ze wymagane jest person bezposrednio w scope
angular.module('salesPath2')
    .directive('personForm', [
      function() {
        return {
          restrict: 'E',
          replace: true,
          scope: {
            collapsed: '=',
            owner: '@',
            personData: '='
          },
          templateUrl: 'salesPath2Template/pages/shortPath/personForm.tpl.html',
          controller: ['$scope', 'sp2CommonHelper', 'coownerHelper', 'CONSTANTS', 'mainDataContainer', 'actionHelper', 'personHelper', 'ContactModelConstants', 'personServiceHelper', 'dictionaryServiceHelper', 'IdentityDocumentModel', 'AddressModelConstants', 'CONFIG', 'vehicleHelper', 'ihestiaConfigHelper',
            function($scope, sp2CommonHelper, coownerHelper, CONSTANTS, mainDataContainer, actionHelper, personHelper, ContactModelConstants, personServiceHelper, dictionaryServiceHelper, IdentityDocumentModel, AddressModelConstants, CONFIG, vehicleHelper, ihestiaConfigHelper) {
              $scope.showElements = {
                PKD: false,
                Regon: false,
                Nip: false,
                clauses: true,
                foreigner: false
              };

              $scope.hideElements = {
                //secondAddr: czy posiada adres korespondenycjny
                secondAddr: true
              };
            
              $scope.numericSettings = {
                decimal: '',
                separator: '',
                negative: false,
                absolute: true,
                allowBeginZero: true
              };        
              
              $scope.numericPhoneSettings = {
                decimal: '',
                separator: '',
                negative: false,
                absolute: true,
                allowBeginZero: true
              };
            
              $scope.services = {
                firstNamesSvc: personServiceHelper.getFirstNameService(),
                lastNamesSvc: personServiceHelper.getLastNameService(),
                addressSvc: dictionaryServiceHelper.getDictionaryAddressService()
              };

              $scope.tplData = {
                countryPrefix: '+48',
                contacts: {}
              };
              $scope.today = ihestiaConfigHelper.get('serverData', 'TODAY');

              //ustawiamy domyślnie +48, jeżeli w danych jest inaczej to wartośc zostanie nadpisana lub ustawiona na pustą.
              angular.forEach($scope.personData.contacts, function(elem) {
                $scope.tplData.contacts[elem.code] = elem.value;
                if (elem.code === 'komo') {
                  $scope.tplData.countryPrefix = elem.countryPrefix;
                }
              });

              $scope.updateContacts = function() {                
                var contacts = [];
                angular.forEach($scope.tplData.contacts, function(val, code) {
                  if (val) {
                    contacts.push({
                      code: code,
                      countryPrefix: [ContactModelConstants.CONTACT_TYPE_DOMO, ContactModelConstants.CONTACT_TYPE_KOMO, ContactModelConstants.CONTACT_TYPE_SLOZ].indexOf(code) !== -1 ? $scope.tplData.countryPrefix : null,
                      value: val
                    });
                  }
                });
                $scope.personData.contacts = contacts;
              };

              $scope.foreignerDocument = {};
              if ($scope.personData.citizenshipCode !== 'PL') {
                $scope.showElements.foreigner = true;
                if (angular.isDefined($scope.personData.documents[0])) {
                  $scope.foreignerDocument = $scope.personData.documents[0];
                }
              } else {
                $scope.foreignerDocument = (new IdentityDocumentModel()).getData();
                $scope.foreignerDocument.code = '';
              }

              $scope.$watch('foreignerDocument', function(newVal) {                
                if ($scope.showElements.foreigner) {
                  $scope.personData.documents = [];
                  $scope.personData.documents[0] = newVal;
                } else {
                  $scope.personData.documents = [];
                  $scope.personData.citizenshipCode = 'PL';
                }
              }, true);

              $scope.nationalities = [];
      
              //domyślna wartość dla listy wyboru narodowości
              $scope.nationalities[0] = {
                code: 'BRAK',
                description: 'BRAK',
                name: 'BRAK'
              };
      
              angular.forEach(personHelper.nationalities, function(item) {
                $scope.nationalities.push(item);
              });
              $scope.identityDocumentTypes = personHelper.identityDocumentTypes;

              if ($scope.personData.addresses && 
                  $scope.personData.addresses[1] && 
                  $scope.personData.addresses[1].code === AddressModelConstants.ADDRESS_TYPE_KORE) {
                $scope.hideElements.secondAddr = false;
              }

              if (angular.isUndefined($scope.personData.addresses[0])) {
                $scope.personData.addresses[0] = {
                  city: null,
                  postalCode: null,
                  streetPrefix: null,
                  street: null
                };
              }
              $scope.copyCorrespondenceAddress = angular.isUndefined($scope.personData.addresses[1]) 
                ? {
                    city: null,
                    postalCode: null,
                    streetPrefix: null,
                    street: null
                  } 
                : $scope.personData.addresses[1];
              $scope.copyCorrespondenceAddress.code = AddressModelConstants.ADDRESS_TYPE_KORE;
              
              $scope.onPeselChange = function() {
                if (!!$scope.personData.pesel && $scope.personData.pesel.isValidPESEL()) {
                  $scope.personData.birthDate = $scope.personData.pesel.peselToBirthdate();
                  $scope.personData.gender = $scope.personData.pesel.peselToSex();
                }
              };
              
              $scope.foreignerStateChanged = function() {
                if ($scope.showElements.foreigner && $scope.personData.citizenshipCode === 'PL' && angular.isDefined($scope.nationalities[0])) {
                  //szukamy pierwszego z brzegu kodu, byle nie polskiego
                  $scope.personData.citizenshipCode = $scope.nationalities[0].code;
                }
              };

              /**
               * usunięcie osoby
               */
              $scope.removePerson = function(personId) {
                sp2CommonHelper.showConfirmModal({
                  treatLabelAsI18nCode: true,
                  size: 'sm',
                  title: 'sp2.modal.info.title',
                  text: 'sp2.modal.removeCoownerConfirmInfo',
                  okBtnCallback: function() {                  
                    var object = coownerHelper.getSelectedObject(CONSTANTS.PRODUCT_TYPE_VEHICLE);
                    var coowners = object.getAdditionalData('coowners');
                    if (coowners.indexOf(personId) !== -1) {
                      coowners.splice(coowners.indexOf(personId), 1);
                      // dodatkowe usuniecie z currentlyEditedVehicleData
                      vehicleHelper.currentlyEditedVehicleData.vehicleAdditionalData.coowners.splice(vehicleHelper.currentlyEditedVehicleData.vehicleAdditionalData.coowners.indexOf(personId), 1);
                    }
                    $scope.personData.deleted = true;

                    if (coowners.length === 0) {
                      vehicleHelper.currentlyEditedVehicleData.vehicleDynamicValues._hasCoowners = false;
                    }
                  }
                });
              };   

              $scope.noDrivingLicenceChanged = function() {
                $scope.personData.dynamicValues.drivingLicenceIssueDate = null;
              };

              $scope.hideElementSecondAddrChanged = function() {
                if ($scope.hideElements.secondAddr) {
                  $scope.personData.addresses.splice(1,1);
                } else {
                  $scope.personData.addresses[1] = $scope.copyCorrespondenceAddress;
                }
              };
          }]
        };
      }]);